"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-nested-ternary */
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var Table_1 = __importDefault(require("@material-ui/core/Table"));
var TableHead_1 = __importDefault(require("@material-ui/core/TableHead"));
var TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));
var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
var TableFooter_1 = __importDefault(require("@material-ui/core/TableFooter"));
var TablePagination_1 = __importDefault(require("@material-ui/core/TablePagination"));
var TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var DataTable_css_1 = __importDefault(require("./DataTable-css"));
var DataTable = function (_a) {
    var _b = _a.data, data = _b === void 0 ? [] : _b, props = __rest(_a, ["data"]);
    var internalClasses = DataTable_css_1.default;
    var _c = react_1.default.useState(props.page || 0), page = _c[0], setPage = _c[1];
    var _d = react_1.default.useState(props.rowsPerPage
        ? props.rowsPerPage
        : props.paginationList
            ? props.paginationList[0]
            : 5), rowsPerPage = _d[0], setRowsPerPage = _d[1];
    var handleChangePage = function (event, pageNumber) {
        setPage(pageNumber);
        if (props.onChangePage) {
            props.onChangePage(event, pageNumber);
        }
    };
    react_1.default.useEffect(function () {
        if (data.length < page * rowsPerPage) {
            setPage(Math.floor(data.length / rowsPerPage));
        }
    }, [data, page, rowsPerPage]);
    var getFilteredData = function () {
        if (!props.filterString || !props.filterKeys) {
            // Return the data as the filter is not set up
            return data;
        }
        var returnData = data.filter(function (record) {
            return props.filterKeys.some(function (filterKey) {
                return (record[filterKey] || "")
                    .toLowerCase()
                    .indexOf(props.filterString.toLowerCase()) > -1;
            }) ||
                props.filterKeys
                    .map(function (filterKey) { return record[filterKey] || ""; })
                    .join(" ")
                    .toLowerCase()
                    .indexOf(props.filterString.toLowerCase()) > -1;
        });
        if (returnData.length < rowsPerPage * page) {
            setPage(Math.floor(returnData.length / rowsPerPage));
        }
        return returnData;
    };
    var handleChangeRowsPerPage = function (e) {
        var newRowsPerPage = e.target.value;
        setRowsPerPage(newRowsPerPage);
        if (page * newRowsPerPage > getFilteredData().length) {
            setPage(Math.floor(getFilteredData().length / newRowsPerPage));
        }
        if (props.onChangeRowsPerPage) {
            props.onChangeRowsPerPage(e);
        }
    };
    var columnCount = props.columns
        .map(function (col) { var _a; return ((_a = col.children) === null || _a === void 0 ? void 0 : _a.length) || 1; })
        .reduce(function (a, b) { return a + b; }, 0);
    return (react_1.default.createElement("div", { className: "invosys-ui-DataTable " + (props.className || "") + " ", style: __assign(__assign({}, internalClasses[props.fixedHeader
            ? "invosys-ui-DataTable-fixedWrapper"
            : "invosys-ui-DataTable"]), (props.style || {})) },
        (props.tableTitle || props.tableSubtitle) && (react_1.default.createElement(Grid_1.default, { container: true, justifyContent: "space-between", style: { height: "70px" } },
            react_1.default.createElement(Grid_1.default, { item: true }, props.tableTitle && (react_1.default.createElement(Typography_1.default, { variant: "h6", style: { padding: "16px 24px" } }, props.tableTitle))),
            react_1.default.createElement(Grid_1.default, { item: true }, props.tableSubtitle && (react_1.default.createElement(Typography_1.default, { variant: "h6", style: { padding: "16px 24px" } }, props.tableSubtitle))))),
        react_1.default.createElement("div", { className: props.fixedHeader
                ? "invosys-ui-DataTable-fixedTableWrapper"
                : "invosys-ui-DataTable-tableWrapper", style: __assign(__assign({}, internalClasses[props.fixedHeader
                ? "invosys-ui-DataTable-fixedTableWrapper"
                : "invosys-ui-DataTable-tableWrapper"]), (props.style || {})) },
            react_1.default.createElement(Table_1.default, { className: (props.fixedHeader ? "invosys-ui-DataTable-fixedTable" : "") + " " + (props.tableClassName || ""), style: __assign(__assign({}, (props.fixedHeader
                    ? internalClasses["invosys-ui-DataTable-fixedTable"]
                    : {})), (props.tableStyle || {})), size: props.dense ? "small" : "medium" },
                react_1.default.createElement(TableHead_1.default, { style: __assign({}, (props.fixedHeader
                        ? internalClasses["invosys-ui-DataTable-fixedHeader"]
                        : {})) },
                    react_1.default.createElement(TableRow_1.default, null, (props.columns || []).map(function (columnDef, index) { return (react_1.default.createElement(TableCell_1.default, { width: columnDef.width, key: index, className: columnDef.headerClass, rowSpan: props.columns.some(function (col) { return col.children; }) &&
                            !columnDef.children
                            ? 2
                            : 1, colSpan: (columnDef.children || []).length || 1 },
                        react_1.default.createElement(Typography_1.default, { className: internalClasses["invosys-ui-DataTable-tableHeader"] }, columnDef.title))); })),
                    props.columns.some(function (col) { return col.children; }) && (react_1.default.createElement(TableRow_1.default, null, (props.columns || [])
                        .filter(function (colDef) { return colDef.children; })
                        .map(function (columnDef) {
                        return columnDef.children.map(function (childDef, idx) { return (react_1.default.createElement(TableCell_1.default, { key: idx, className: childDef.headerClass },
                            react_1.default.createElement(Typography_1.default, { className: internalClasses["invosys-ui-DataTable-tableHeader"] }, childDef.title))); });
                    })))),
                react_1.default.createElement(TableBody_1.default, null, getFilteredData()
                    .slice(page * rowsPerPage, (page + 1) * rowsPerPage)
                    .map(function (record, idx) { return (react_1.default.createElement(TableRow_1.default, { key: idx, "data-key": idx }, (props.columns || []).map(function (column, idx2) {
                    return column.children ? (column.children.map(function (childDef, idx3) { return (react_1.default.createElement(TableCell_1.default, { key: idx3, className: typeof childDef.columnClass === "function"
                            ? childDef.columnClass(record)
                            : childDef.columnClass }, childDef.render
                        ? childDef.render(record)
                        : record[childDef.field])); })) : (react_1.default.createElement(TableCell_1.default, { key: idx2, className: typeof column.columnClass === "function"
                            ? column.columnClass(record)
                            : column.columnClass }, column.render
                        ? column.render(record)
                        : record[column.field]));
                }))); })),
                react_1.default.createElement(TableFooter_1.default, { style: __assign(__assign({}, (props.fixedHeader
                        ? internalClasses["invosys-ui-DataTable-fixedFooter"]
                        : {})), (props.tableStyle || {})) },
                    react_1.default.createElement(TableRow_1.default, null,
                        react_1.default.createElement(TableCell_1.default, { colSpan: columnCount },
                            react_1.default.createElement(Grid_1.default, { container: true, justifyContent: "space-between" },
                                react_1.default.createElement(Grid_1.default, { item: true }, props.footerActions),
                                react_1.default.createElement(Grid_1.default, { item: true },
                                    react_1.default.createElement(TablePagination_1.default, { component: "span", count: props.count || getFilteredData().length, page: page, onPageChange: handleChangePage, rowsPerPageOptions: props.paginationList || [5, 10, 25, 50, 100], rowsPerPage: rowsPerPage, onRowsPerPageChange: handleChangeRowsPerPage }))))))))));
};
exports.default = DataTable;
DataTable.propTypes = {
    // Wrapper styles
    className: prop_types_1.default.string,
    style: prop_types_1.default.object,
    // Titles
    tableTitle: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.node,
        prop_types_1.default.array
    ]),
    tableSubtitle: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.node,
        prop_types_1.default.array
    ]),
    // Table Styles
    tableClassName: prop_types_1.default.string,
    tableStyle: prop_types_1.default.object,
    dense: prop_types_1.default.bool,
    // Table info
    columns: prop_types_1.default.array,
    count: prop_types_1.default.number,
    data: prop_types_1.default.array,
    filterString: prop_types_1.default.string,
    filterKeys: prop_types_1.default.array,
    fixedHeader: prop_types_1.default.bool,
    footerActions: prop_types_1.default.node,
    onChangePage: prop_types_1.default.func,
    onChangeRowsPerPage: prop_types_1.default.func,
    page: prop_types_1.default.number,
    paginationList: prop_types_1.default.array,
    rowsPerPage: prop_types_1.default.number
};
